<template>
  <div>
    <v-icon
      x-large
      color="black"
      :style="style"
    >
      {{ icon }}
    </v-icon>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  },

  computed: {
    icon() {
      switch (this.color) {
        case 'green':
          return '$vuetify.icons.trafficLightGo'
        case 'orange':
          return '$vuetify.icons.trafficLightSlow'
        case 'red':
          return '$vuetify.icons.trafficLightStop'
        default:
          return '$vuetify.icons.trafficLight'
      }
    },
    style() {
      let style = ''
      const secondaryColor = this.secondaryColor
      if (secondaryColor !== '') {
        style += `--fa-secondary-color: ${secondaryColor}; --fa-secondary-opacity: 1;`
      }
      return style
    },
    secondaryColor() {
      switch (this.color) {
        case 'green':
          return 'lightgreen'
        case 'orange':
          return 'orange'
        case 'red':
          return 'red'
        default:
          return ''
      }
    }
  }
}
</script>
